module.exports = __webpack_public_path__ + "img/corrugatedBox2.c58621c1.jpg";